<template>
  <div>
    <div v-for="(field_errors, field_name) in errors" :key="field_name" :class="errorClasses">
      <p v-for="message in field_errors" :key="message" class="my-2">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Object,
      default: {},
    },
    errorClasses: {
      type: String,
      default: 'text-red-400 my-2',
    },
  },
};
</script>
